import React, { Component } from "react";
import { Snackbar, Alert } from '@mui/material';

import Events from '../service/Events';

class InfoSnackbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      message: null,
      isError: false,
      isSuccess: false
    }
  }

  componentDidMount() {
    Events.onResult.on("error", (_errorMessage) => {
      this.setState({ isError: true, show: true, message: _errorMessage });
    });

    Events.onResult.on("success", (_successMessage) => {
      this.setState({ isSuccess: true, show: true, message: _successMessage ? _successMessage : "Erfolg!" });
    });
  }

  close = () => {
    this.setState({ show: false, isSuccess: false, isError: false, message: null });
  }

  render() {
    return (
      <div>
        <Snackbar 
          open={this.state.show} 
          autoHideDuration={5000} 
          onClose={this.close}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert 
            onClose={this.close} 
            severity={this.state.isError ? "error" : this.state.isSuccess ? "success" : "info"} 
            variant="filled"
            sx={{ 
              minWidth: { xs: '280px', sm: '400px' },
              maxWidth: { xs: 'calc(100vw - 32px)', sm: '600px' },
              fontSize: { xs: '0.875rem', sm: '0.9375rem' },
              borderRadius: { xs: '8px', sm: '12px' },
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              '& .MuiAlert-message': {
                padding: '8px 0',
                width: '100%',
                display: 'flex',
                alignItems: 'center'
              }
            }}
          >
            {this.state.message}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

export default InfoSnackbar;